import React, { useRef, useState } from 'react';
import { Base as DataTable } from '@reusejs/react-tables';
// import { useItemSelector } from '@reusejs/react-utils';
import { DataLoadOrchestrator } from '@reusejs/react-utils';
import { Loader } from '@reusejs/react-loaders';
import { getAllUsers } from '@nx-monorepo/services';
import formatDate from '../utils/formatDate';
import { setUsersLength } from '@nx-monorepo/store';
import { useDispatch } from 'react-redux';
import EmptyState from '../components/reusables/EmptyState';

const Data = ({ response }) => {
  const tableRef = useRef(null);

  const fetchProfiles = () => {
    try {
      return response.data;
    } catch (error) {
      return error;
    }
  };

  const config = {
    tableWrapperClasses: 'overflow-hidden mx-5 border rounded-lg',
    tableClasses: 'min-w-full divide-y divide-white px-5',
    headerClasses: 'relative py-4 px-5',
    rowEvenClasses: 'bg-gray-100',
    filterable: false,
    columns: [
      {
        label: 'Name',
        identifier: 'name',
        resolver: (d) => {
          return (
            <div
              onClick={() => {
                return;
              }}
            >
              {d.name ? d.name : '-'}
            </div>
          );
        },
      },
      {
        label: 'Email',
        identifier: 'email',
        resolver: (d) => {
          return (
            <div className="text-column-blue">{d.email ? d.email : '-'}</div>
          );
        },
      },
      {
        label: 'Mobile',
        identifier: 'mobile',
        resolver: (d) => {
          return d.mobile ? d.mobile : '-';
        },
      },
      {
        label: 'Email verified at',
        identifier: 'email_verified_at',
        resolver: (d) => {
          return d.email_verified_at
            ? formatDate(new Date(d.email_verified_at), 'ymd')
            : '-';
        },
      },
      {
        label: 'Mobile verified at',
        identifier: 'mobile_verified_at',
        resolver: (d) => {
          return d.mobile_verified_at
            ? formatDate(new Date(d.mobile_verified_at), 'ymd')
            : '-';
        },
      },
      {
        label: 'Registered At',
        identifier: 'created_at',
        resolver: (d) => {
          return d.created_at ? formatDate(new Date(d.created_at), 'ymd') : '-';
        },
      },
    ],
  };

  return (
    <div className="mt-10">
      <DataTable
        ref={tableRef}
        config={config}
        defaultSortColumn={0}
        perPage={5}
        dataSource={async (params) => {
          try {
            let response = await fetchProfiles(params);

            return {
              data: response.reverse(),
              pagination: {
                total: 0,
              },
            };
          } catch (error) {
            console.log(error);
          }
        }}
      />
    </div>
  );
};

const SectionLoader = () => {
  return (
    <div className="flex h-96 items-center justify-center">
      <Loader />
    </div>
  );
};

const ErrorState = ({ response }) => {
  return (
    <div className="flex h-96 items-center justify-center">
      {response.data ? response.data : 'Something went wrong!'}
    </div>
  );
};

export default function ({ mode, callAction, filterBy }) {
  const orchestratorRef = useRef(null);
  let dispatch = useDispatch();

  const handler = async () => {
    try {
      let result = await getAllUsers();

      if (result.length > 0) {
        dispatch(setUsersLength(result.length));
      }

      if (Object.keys(result).length === 0) {
        return {
          state: 'empty',
          data: result,
        };
      }

      return {
        state: 'data',
        data: result,
      };
    } catch (error) {
      return {
        state: 'error',
        data: 'Something went wrong',
      };
    }
  };

  const emptyConfigHeaderCols = [
    {
      label: 'Name',
      identifier: 'name',
      resolver: () => {},
    },
    {
      label: 'Email',
      identifier: 'email',
      resolver: () => {},
    },
    {
      label: 'Mobile',
      identifier: 'mobile',
      resolver: () => {},
    },
    {
      label: 'Email verified at',
      identifier: 'email_verified_at',
      resolver: () => {},
    },
    {
      label: 'Mobile verified at',
      identifier: 'mobile_verified_at',
      resolver: () => {},
    },
    {
      label: 'Registered At',
      identifier: 'created_at',
      resolver: () => {},
    },
  ];

  return (
    <DataLoadOrchestrator
      handler={handler}
      ref={orchestratorRef}
      components={{
        data: React.forwardRef((props, ref) => (
          <span ref={ref}>
            <Data
              mode={mode}
              callAction={callAction}
              filterBy={filterBy}
              {...props}
            />
          </span>
        )),
        loading: SectionLoader,
        empty: React.forwardRef((props, ref) => (
          <span ref={ref}>
            <EmptyState tableHeadColumns={emptyConfigHeaderCols} {...props} />
          </span>
        )),
        error: ErrorState,
      }}
    />
  );
}
